import {MediaImage} from "../media/media--image";
import {Button} from "../../atoms/button";
import classNames from "classnames";
import dynamic from "next/dynamic";
import {ARTICLE_TEASER_IMAGE_STYLE} from "../../../types/image-styles";
const FormattedText = dynamic(() => import("../../formatted-text").then((mod) => mod.FormattedText));

export function ParagraphImageAsideCta({paragraph, ...props}) {
  const imageSize = paragraph?.field_image_aside_cta_width ?? "";
  const fillHeight = paragraph?.field_image_aside_cta_fill ?? false;

  return (
    <div className="w-full bg-white drop-shadow-sm rounded-md">
      <div className={classNames("flex gap-6 flex-col md:flex-row", {
        "items-center": !fillHeight,
        "items-stretched": fillHeight,
      })}>
        <div className={classNames({
          "w-full md:max-w-[365px]": !imageSize,
          "w-full md:w-1/2": imageSize === "1/2",
          "w-full md:w-1/3": imageSize === "1/3",
          "w-full md:w-1/4": imageSize === "1/4",
          "w-full md:w-2/3": imageSize === "2/3",
          "w-full md:w-3/4": imageSize === "3/4",
          "md:order-1": paragraph?.field_iac_side === "right",
        })}>
          {paragraph?.field_iac_image && (
            <MediaImage media={paragraph?.field_iac_image}
                        imageStyle={ARTICLE_TEASER_IMAGE_STYLE}
                        childClass={classNames("w-full mx-auto rounded-tl-[4px] md:rounded-bl-[4px]", {"h-full": fillHeight})}
                        className={classNames({"h-full": fillHeight})}
                        style={{objectFit: fillHeight ? "cover" : "fill", objectPosition: fillHeight ? "left" : "center"}} />
          )}
        </div>
        <div className={classNames("justify-center p-6 md:pr-12 flex flex-col", {
            "w-full md:w-1/2": imageSize === "1/2",
            "w-full md:w-2/3": imageSize === "1/3",
            "w-full md:w-3/4": imageSize === "1/4",
            "w-full md:w-1/3": imageSize === "2/3",
            "w-full md:w-1/4": imageSize === "3/4",
        })}>
          {paragraph?.field_iac_sub_title && (
            <h2 className="font-bold text-primary text-xl pb-2">
              {paragraph.field_iac_sub_title}
            </h2>
          )}
          {paragraph?.field_iac_title && (
            <h2 className={classNames(
              "text-3xl",
              {
                "text-black font-bold pb-2": paragraph?.field_iac_sub_title?.length > 0,
                "text-primary font-semibold pb-4": !paragraph?.field_iac_sub_title?.length
              }
            )}>
              {paragraph.field_iac_title}
            </h2>
          )}
          {paragraph?.field_iac_description?.processed && (
            <div className="text-xl prose font-light">
              <FormattedText processed={paragraph.field_iac_description.processed}/>
            </div>
          )}
          {(paragraph?.field_iac_buttons?.length || paragraph?.field_iac_link?.url) ? (
            <div className={classNames(
              "flex gap-2 flex-wrap mt-4 justify-self-end [&>.button]:w-full md:[&>.button]:w-auto",
            )}>
              {paragraph?.field_iac_link?.url && (
                <Button
                  href={paragraph.field_iac_link.url}
                  height={22} width={22}
                  icon={paragraph.field_iac_icon?.name}
                  iconify={paragraph.field_iac_icon?.iconify}
                  position={"right"}
                  containerClassName="w-full md:w-auto flex"
                  color={"primary"} hover={{color: "primary"}}
                  className="py-1 w-full md:w-auto"
                  target={"_blank"}
                >
                  {paragraph.field_iac_link.title}
                </Button>
              )}
              {paragraph?.field_iac_buttons?.length ? paragraph.field_iac_buttons.map((item, key) => {
                if (item?.url) {
                  return <Button key={`content-card-buttons-${paragraph.id}-${item.url}-${key}`} href={item.url} className="py-1.5 px-6 btn-product-details w-auto" hover={{color: "primary"}} invert={false} containerClassName={"!block"}>{item.title}</Button>
                }
                else if (item?.uri && item.uri.startsWith("http")) {
                  return <Button key={`content-card-buttons-${paragraph.id}-${item.uri}-${key}`} href={item.uri} className="py-1.5 px-6 btn-product-details w-auto" hover={{color: "primary"}} invert={false} containerClassName={"!block"} target="_blank">{item.title}</Button>
                }
                else {
                  return <></>
                }
              }): <></>}
            </div>
          ): <></>}
        </div>
      </div>
    </div>
  )
}
